exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".activation-container[data-v-f223999a]{display:flex;justify-content:center;align-items:center;height:100vh}.white-box[data-v-f223999a]{background-color:#fff;padding:20px;border-radius:12px;box-shadow:0 4px 8px rgba(0,0,0,.1);width:500px;text-align:center}.footer[data-v-f223999a],.header[data-v-f223999a]{padding:16px;background-color:#f9f9f9;border-radius:8px}.content[data-v-f223999a]{padding:16px}.info-box[data-v-f223999a]{margin:12px 0}.subtitle[data-v-f223999a]{font-size:20px;font-weight:600;margin-bottom:4px}.value[data-v-f223999a]{font-size:18px;margin-bottom:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/user-activation/Activate.vue?vue&type=style&index=0&id=f223999a&prod&scoped=true&lang=css&
// module id = 945
// module chunks = 0